function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable linebreak-style */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var ProgressBar = /*#__PURE__*/function (_Component) {
  _inherits(ProgressBar, _Component);

  var _super = _createSuper(ProgressBar);

  function ProgressBar(props) {
    var _this;

    _classCallCheck(this, ProgressBar);

    _this = _super.call(this, props);
    _this.defaultDictionary = {
      HearingTest: {
        ButtonResponse: 'Questions',
        Calibration: 'Calibration',
        Tone: 'Sound test'
      }
    };
    _this.state = {
      dictionary: _this.defaultDictionary
    };
    return _this;
  }

  _createClass(ProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var theLang = $('html').attr('lang');
      var dict = this.defaultDictionary;
      DGS.Dictionary.getInstance().getTexts(dict, function () {
        _this2.setState(_objectSpread(_objectSpread({}, _this2.state), {}, {
          dictionary: dict
        }));
      }, theLang);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var items = [];
      var margin = 3;
      var sections = [{
        name: 'ButtonResponse',
        indexes: []
      }, {
        name: 'Calibration',
        indexes: []
      }, {
        name: 'Tone',
        indexes: []
      }];
      var envSteps = this.props.steps.filter(function (step) {
        return step !== undefined;
      });
      envSteps.forEach(function (step, index) {
        if (step.StepViewType === 'ButtonResponse') {
          var section = sections.find(function (item) {
            return item.name === 'ButtonResponse';
          });
          section.indexes.push(index + 1);
        }

        if (step.StepViewType.includes('Calibration')) {
          var _section = sections.find(function (item) {
            return item.name.includes('Calibration');
          });

          _section.indexes.push(index + 1);
        }

        if (step.StepViewType === 'Tone') {
          var _section2 = sections.find(function (item) {
            return item.name === 'Tone';
          });

          _section2.indexes.push(index + 1);
        }
      });
      var sectionsLength = sections.length;
      var percentWidth = 100 / sectionsLength;
      var currentSectionStep = sections.findIndex(function (section) {
        return section.indexes.includes(_this3.props.currentStep);
      }) + 1;

      for (var i = 1; i <= sectionsLength; i += 1) {
        var isDone = i <= currentSectionStep;
        var isCurrent = i === currentSectionStep;
        items.push( /*#__PURE__*/React.createElement("div", {
          className: "progress-bar__block\n        ".concat(isDone ? 'progress-bar__block--active' : '', "\n        ").concat(isCurrent ? 'progress-bar__block--current' : '', "\n        "),
          key: i,
          style: {
            width: "calc(".concat(percentWidth, "% - ").concat(margin, "px)")
          }
        }));
      }

      var ballonXPos = percentWidth * currentSectionStep - percentWidth / 2;
      return /*#__PURE__*/React.createElement("div", {
        className: "progress-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "progress-bar__blocks"
      }, items), /*#__PURE__*/React.createElement("div", {
        className: "progress-bar__balloon",
        style: {
          left: "".concat(ballonXPos, "%")
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "progress-bar__text"
      }, this.state.dictionary.HearingTest[sections[currentSectionStep - 1].name])));
    }
  }]);

  return ProgressBar;
}(Component);

ProgressBar.propTypes = {
  steps: PropTypes.any.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};
export default ProgressBar;